/* ===== src/utils/generateEpub.ts ===== */
import { apiRequest } from '../../services/api';
import { ProjectState } from '../types';

export async function generateEpub(
  projectState: ProjectState,
  selectedSections: any = { 
    frontMatter: { enabled: true }, 
    chapters: { enabled: true }, 
    backMatter: { enabled: true } 
  },
  includeBackground: boolean = true
): Promise<Blob> {
  try {
    const response = await apiRequest('/api/export/epub', 'POST', {
      projectId: projectState.projectId,
      selectedSections,
      includeBackground
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to generate EPUB');
    }

    return await (response as any).blob();
  } catch (error) {
    console.error('EPUB generation error:', error);
    throw error;
  }
}